import { useState, useEffect } from "react";

export default function Toast({ message }) {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    if (message) {
      setText(message);
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [message]);

  return (
    <div className={`toast ${visible ? "show" : ""}`} data-testid="toast-notification">
      {text}
    </div>
  );
}
